export enum MoveBackChasePageType {
  IncorrectMember = 1,
  Invoice = 2,
  Illegible = 3,
  Remove = 4,
  SendPagesToDocumentIntake = 5,
}
